/**
 * Flight Mode checkpoint data — maps portfolio sections to waypoints.
 * Content is sourced from the real portfolio (Home/About/Projects/Contact).
 */

export const CHECKPOINTS = [
  {
    code: 'ORGN',
    label: 'INTRODUCTION',
    section: 'home',
    eyebrow: 'DEPARTURE · MEET THE PILOT',
    title: 'Waleed Abdullah',
    subtitle: 'Software Engineer · AI/ML Engineer · UI/UX Designer',
    body: "Welcome aboard. I'm a passionate engineer with 2+ years of hands-on experience building full-stack web applications, AI-powered systems, and immersive UI/UX experiences. Based between Abu Dhabi and Islamabad, available globally.",
    type: 'intro',
    color: '#667eea',
    icon: '✦',
  },
  {
    code: 'ABOT',
    label: 'ABOUT',
    section: 'about',
    eyebrow: 'EN ROUTE · THE JOURNEY',
    title: 'About Me',
    subtitle: 'The Story So Far',
    body: "My passion lies in transforming complex problems into elegant solutions — whether it's training life-changing AI models, designing intuitive user experiences, or engineering scalable platforms.",
    type: 'about',
    color: '#8b5cf6',
    icon: '◈',
    stats: [
      { number: '20+', label: 'Projects Delivered' },
      { number: '2+', label: 'Years Experience' },
      { number: '95%', label: 'Client Satisfaction' },
      { number: '24/7', label: 'Available for Code' },
    ],
  },
  {
    code: 'SKIL',
    label: 'SKILLS',
    section: 'about',
    eyebrow: 'INSTRUMENT CHECK · SYSTEMS CALIBRATED',
    title: 'Technical Arsenal',
    subtitle: 'Skills & Technologies',
    body: 'Full-stack development across web, AI/ML, mobile, and cloud infrastructure.',
    type: 'skills',
    color: '#06b6d4',
    icon: '⬡',
    skillGroups: [
      {
        category: 'Frontend',
        items: ['React', 'Next.js', 'TypeScript', 'Tailwind CSS', 'Framer Motion'],
      },
      {
        category: 'Backend',
        items: ['Node.js', 'Express.js', 'Python', 'MongoDB', 'PostgreSQL'],
      },
      {
        category: 'AI / ML',
        items: ['PyTorch', 'TensorFlow', 'OpenCV', 'YOLOv8', 'NLP'],
      },
      {
        category: 'DevOps',
        items: ['Docker', 'Kubernetes', 'AWS', 'GitHub Actions', 'CI/CD'],
      },
    ],
  },
  {
    code: 'PROJ',
    label: 'PROJECTS',
    section: 'projects',
    eyebrow: 'FLIGHT LOG · RECENT DESTINATIONS',
    title: 'Projects',
    subtitle: '6 Notable Destinations',
    body: 'A selection of projects spanning full-stack, AI/ML, and mobile development.',
    type: 'projects',
    color: '#f093fb',
    icon: '◉',
    projects: [
      {
        stamp: 'DXB',
        name: 'Tourism Website',
        tech: 'React · Express · MongoDB',
        live: 'https://safariadventuredubai.com',
        desc: 'Full tourism portal with real-time bookings for safari adventures and cultural experiences.',
      },
      {
        stamp: 'MUS',
        name: 'Music Streaming Platform',
        tech: 'React · Redux · Web Audio API',
        github: 'https://github.com/WaleedAbdullah2215/MusicPlayer_MUSUNG',
        desc: 'Full-featured streaming app with playlists, search, shuffle and repeat.',
      },
      {
        stamp: 'S2L',
        name: 'Sketch2Life — AI 3D',
        tech: 'Python · TripoSR · PyTorch',
        github: 'https://github.com/WaleedAbdullah2215/GenAi_2dto3d',
        desc: 'Transform 2D sketches into high-quality 3D models using generative AI.',
      },
      {
        stamp: 'NAV',
        name: 'Campus AR Navigation',
        tech: 'React · ARCore · Firebase',
        desc: 'Augmented reality indoor/outdoor navigation system for universities.',
      },
      {
        stamp: 'FYP',
        name: 'AI Driving Assistance System',
        tech: 'Python · OpenCV · YOLO · MiDaS',
        desc: 'Real-time driving assistant — lane detection, obstacle avoidance, drowsiness alerts.',
      },
      {
        stamp: 'MDR',
        name: 'MediRemind Telegram Bot',
        tech: 'n8n · Telegram API · Twilio',
        desc: 'Medication reminder bot with caregiver escalation and adherence logging via n8n.',
      },
    ],
  },
  {
    code: 'LAND',
    label: 'CONTACT',
    section: 'contact',
    eyebrow: 'REQUESTING CLEARANCE · LET\'S CONNECT',
    title: "Let's Create Something",
    subtitle: 'Ready to collaborate?',
    body: "Whether it's a full-stack web app, an AI-driven product, or exciting new tech — I'm always up for the challenge. Response within 24 hours.",
    type: 'contact',
    color: '#fb923c',
    icon: '⊕',
    contacts: [
      { label: 'Email', href: 'mailto:waleedabdullah2004@gmail.com', icon: '✉' },
      { label: 'LinkedIn', href: 'https://linkedin.com/in/waleedabdullah2004', icon: '🔗' },
      { label: 'GitHub', href: 'https://github.com/WaleedAbdullah2215', icon: '⌥' },
      { label: 'WhatsApp', href: 'https://wa.me/+971501951041', icon: '◎' },
    ],
  },
];

export const CHECKPOINT_COUNT = CHECKPOINTS.length;
